'use client';

import React, { FC } from 'react';
import { ApiClimateArea, ApiClimateInfo } from '../../../api/model';
import useMonthLabels from '@/Hooks/useMonthLabels';

const ClimateTableHeader: FC<{ climateArea: ApiClimateArea }> = ({ climateArea }) => {
  const monthLabels = useMonthLabels(true);

  return (
    <>
      {climateArea.climateInfos?.map((climateInfo: ApiClimateInfo, idx: number) => (
        <th className="climate-table__header-col" key={climateInfo.name}>
          {monthLabels[idx]}
        </th>
      ))}
    </>
  );
};
export default ClimateTableHeader;
